import { Checkbox, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommExAppControlTrailerTracking extends Layout {
    checkboxAddTrailerDetentionMiscellaneousBillingRecord: Checkbox;
    checkboxOverwriteExistingWithHookedTrailer: Checkbox;
    checkboxTrailerConnect: Checkbox;
    checkboxTrailerDisconnect: Checkbox;
    checkboxTrailerUnitBatteryStatus: Checkbox;
    checkboxUpdateReeferFuelLevel: Checkbox;
    checkboxUpdateReeferProfileReading: Checkbox;
    checkboxUpdateReturnAir: Checkbox;
    checkboxUpdateSetpoint: Checkbox;
    checkboxUpdateTrailerEmptyStatus: Checkbox;
    checkboxUpdateTrailerOdometer: Checkbox;
    labelTrailerTracking: Label;
    panelLeftColumn: Panel;
    panelRightColumn: Panel;
    panelThree: Panel;
    panelTrailerTrackingSection: Panel;
    sourceMCExAppControl: DataSource;
    textboxBatteryStatusField: Textbox;
    textboxEmptyString: Textbox;
    textboxFuelLevelTrailerField: Textbox;
    textboxFuelPercentField: Textbox;
    textboxLoadedString: Textbox;
    textboxOdometerField: Textbox;
    textboxReeferProfileField: Textbox;
    textboxReturnAirField: Textbox;
    textboxSetpointField: Textbox;
    textboxTrailerEmptyField: Textbox;
}
